module.exports = __webpack_public_path__ + "img/2.32460230.png";